module.exports = __webpack_public_path__ + "img/search.a54df25e.svg";